<template>
  <div class="col-12 flex row justify-start items-center" style="height: 100vh">
    <div
      class="col-12 col-md-6 flex row items-center justify-center q-ml-md-md full-height"
    >
      <div class="login-container spacing-login">
        <div class="login-header flex row col-12 q-my-md justify-center">
          <q-img
            src="@/assets/images/logo.svg"
            spinner-color="white"
            style="width: 60%"
          />
        </div>
        <div class="login-body flex row col-12 q-my-md justify-center">
          <form @submit.prevent="onSubmit" class="form-login row">
            <div class="col-12 q-mt-md field-login">
              <q-input
                outlined
                v-model="login"
                bg-color="white"
                label="Usuário"
                id="username"
                :readonly="alterarSenhaProxLogin"
                dense
                input-class="input-default"
              />
            </div>
            <div class="col-12 q-mt-md field-password">
              <q-input
                type="password"
                bg-color="white"
                outlined
                v-model="password"
                label="Senha"
                :readonly="alterarSenhaProxLogin"
                id="password"
                dense
                input-class="input-default"
              />
            </div>
            <!-- <div v-if="alterarSenhaProxLogin" class="col-12 q-mt-md">
            <q-separator class="separation" />
          </div> -->
            <div class="box-roles col-12 q-mt-md" v-if="alterarSenhaProxLogin">
              <h6 class="text-caption">A senha deve conter:</h6>
              <ul class="q-mt-xs q-mb-none text-caption password-reqs">
                <li :class="reqClasses.minLen">
                  <q-icon :name="icons.minLen" class="q-mr-xs" />Mínimo 8
                  caracteres
                </li>
                <li :class="reqClasses.upper">
                  <q-icon :name="icons.upper" class="q-mr-xs" />Uma letra
                  maiúscula (A-Z)
                </li>
                <li :class="reqClasses.digit">
                  <q-icon :name="icons.digit" class="q-mr-xs" />Um número (0-9)
                </li>
                <li :class="reqClasses.special">
                  <q-icon :name="icons.special" class="q-mr-xs" />Um caractere
                  especial (!@#$…)
                </li>
              </ul>
            </div>
            <div v-if="alterarSenhaProxLogin" class="col-12 q-mt-md">
              <q-input
                type="password"
                bg-color="white"
                outlined
                v-model="newPassword"
                label="Insira sua nova senha"
                :disable="loading"
                dense
                :error="!meetsAll"
                :error-message="
                  meetsAll ? '' : 'A senha não atende aos requisitos'
                "
                :color="meetsAll ? 'positive' : 'negative'"
              />
            </div>
            <div v-if="alterarSenhaProxLogin" class="col-12">
              <q-input
                type="password"
                bg-color="white"
                outlined
                label="Confirme sua nova senha"
                dense
                input-class="input-default"
                v-model="confirmNewPassword"
                :disable="!meetsAll || loading"
                :error="
                  confirmNewPassword.length > 0 &&
                  confirmNewPassword !== newPassword
                "
                :error-message="
                  confirmNewPassword !== newPassword
                    ? 'As senhas não coincidem'
                    : ''
                "
              />
            </div>

            <div class="q-mt-md login-footer flex row col-12 justify-end">
              <q-btn
                class="btn-login"
                style="border-radius: 0.5rem"
                type="submit"
                :label="alterarSenhaProxLogin ? 'Salvar' : 'Login'"
                :loading="loading"
                :disable="!canSubmit && alterarSenhaProxLogin"
                color="primary"
                unelevated
              />
            </div>
          </form>
        </div>
        <div
          class="q-mt-md flex row col-12 justify-between items-center q-px-sm"
        >
          <div class="flex row items-center justify-center">
            <a
              class="text-caption doc-terms text-white"
              href="/files/docs/Termo-de-Uso-Cosmos-Plataforma-Digital.pdf"
              target="_blank"
              >Termos de uso</a
            >
            <div
              style="border-left: 1px solid #eee; height: 16px; margin: 0 8px"
            />
            <a
              class="text-caption doc-terms text-white"
              href="/files/docs/Politica-de-Privacidade-Cosmos-Plataforma-Digital.pdf"
              target="_blank"
              >Privacidade</a
            >
          </div>
          <div>
            <q-img
              src="@/assets/images/powered-by-wtf.svg"
              spinner-color="white"
              width="125px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <q-dialog v-model="model" persistent>
    <q-card>
      <q-card-section>
        <b style="color: red" class="text-h6"
          ><q-icon name="warning" color="red" size="xs" /> Atenção:</b
        >
      </q-card-section>

      <q-card-section class="row items-center">
        <span class="q-ml-sm" style="font-size: 1.15rem"
          >Identificamos outra sessão do sistema ativa para este usuário.</span
        >
        <span class="q-ml-sm" style="font-size: 1.15rem"
          >Como gostaria de prosseguir?</span
        >
      </q-card-section>

      <q-card-actions align="right">
        <q-btn color="grey-4" text-color="black" label="Sair" v-close-popup />
        <q-btn
          color="secondary"
          label="Entrar "
          @click="logoutUserAnotherSession"
          v-close-popup
        />
      </q-card-actions>

      <q-card-section class="row items-center">
        <span class="q-ml-sm"
          >[ Entrar ] Essa ação irá desconectar a outra sessão que está
          aberta.</span
        >
        <span class="q-ml-sm"
          >[ Sair ] Essa ação mantêm a outra sessão em aberto, para você
          continuar seu trabalho dela lá.</span
        >
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import AuthServices from "@/services/AuthServices";
import UserServices from "@/services/UserServices";
import { useQuasar } from "quasar";
import { computed, onMounted } from "vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
export default {
  name: "LoginView",
  setup() {
    const store = useStore();
    const router = useRouter();
    const _authServices = new AuthServices();
    const _userServices = new UserServices();
    const $q = useQuasar();

    onMounted(() => {
      $q.dark.set(false);
    });
    let login = ref("");
    let password = ref("");
    let newPassword = ref("");
    let confirmNewPassword = ref("");
    let userId = ref("");
    let tempAuthToken = "";
    let loading = ref(false);
    let model = ref(false);
    let alterarSenhaProxLogin = ref(false);

    const hasMinLen = computed(() => newPassword.value.length >= 8);
    const hasUpper = computed(() => /[A-Z]/.test(newPassword.value));
    const hasDigit = computed(() => /\d/.test(newPassword.value));
    const hasSpecial = computed(() =>
      /[!@#$%^&*(),.?":{}|<>_\-\\/\[\]=+;`~]/.test(newPassword.value),
    );

    const canSubmit = computed(
      () =>
        meetsAll.value &&
        confirmNewPassword.value.length > 0 &&
        confirmNewPassword.value === newPassword.value,
    );

    const meetsAll = computed(
      () =>
        hasMinLen.value && hasUpper.value && hasDigit.value && hasSpecial.value,
    );

    const icons = computed(() => ({
      minLen: hasMinLen.value ? "check" : "close",
      upper: hasUpper.value ? "check" : "close",
      digit: hasDigit.value ? "check" : "close",
      special: hasSpecial.value ? "check" : "close",
    }));

    const reqClasses = computed(() => ({
      minLen: hasMinLen.value ? "ok" : "nok",
      upper: hasUpper.value ? "ok" : "nok",
      digit: hasDigit.value ? "ok" : "nok",
      special: hasSpecial.value ? "ok" : "nok",
    }));

    async function onSubmit() {
      if (!alterarSenhaProxLogin.value) {
        await authenticate({
          login: login.value,
          password: password.value,
        });
      } else {
        await saveNewPassword();
      }
    }

    async function saveNewPassword() {
      loading.value = true;
      //console.log(userId, newPassword.value);

      let userData = {
        newPassword: newPassword.value,
      };

      _userServices
        .updateFirstLoginPassword(userId, userData, tempAuthToken)
        .then((response) => {
          //console.log("resposta sucesso = " + response.data);

          $q.notify({
            message: `Senha atualizada com sucesso. Aguarde, você será redirecionado para a página de Login.`,
            color: "green-8",
            position: "top",
            onDismiss: () => {
              window.location.reload(); // recarrega depois que a notificação sumir
              loading.value = false;
            },
          });
          //window.location.reload();
        })
        .catch((err) => {
          // console.log(err);

          if (err.response) {
            $q.notify({
              message: `${err.response.message}`,
              color: "red-8",
              position: "top",
            });
          } else {
            $q.notify({
              message: `Não foi possível se conectar ao servidor`,
              color: "orange-8",
              position: "top",
            });
          }
          loading.value = false;
        });
    }

    async function authenticate(formLoginData) {
      loading.value = true;
      _authServices
        .auth(formLoginData)
        .then((response) => {
          response = response.data;

          if (response.data.alterar_senha_proximo_login) {
            alterarSenhaProxLogin.value = true;
            userId = response.data.id_usuario;
            tempAuthToken = response.token;
            return;
          }

          if (response.data.data_login) {
            response.data.data_login = manipulateDateTime(
              response.data.data_login,
            );
          }

          if (response.data.papel == "Agente") {
            _userServices.saveInfoMachine(response.data.id_usuario);
          }

          const loginDate = new Date(Date.now()).toISOString();
          localStorage.setItem("token_plataforma_digital", response.token);

          store.commit("setUserdata", response.data);
          store.commit("setMenu", response.menu || []);
          store.commit("setPermission", response.permissions);
          store.commit("setLoginData", { latestLogin: loginDate });

          if (!store.state.phoneAttendanceData.callerNumber) {
            store.dispatch("timer/startTimer");
          }

          //console.log(response.data);
          if (response.data.id_empresa == 16) {
            store.commit("setCompanyParameters", response.companyParameters);
          }
          //loading.value = false;

          //testarMiniApiIpReporter();
          router.push({ name: "admin" });
        })
        .catch((err) => {
          if (err.response.status == 422) {
            model.value = true;
            userId.value = err.response.data;
            return;
          }
          loading.value = false;
          $q.notify({
            message: `Aviso: ${
              err.response.data ? err.response.data : "Erro ao enviar dados."
            }`,
            color: "orange-8",
            position: "top",
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }

    function processLoginAuthentication(response) {}

    function manipulateDateTime(currentDate) {
      let initialAttendanaceDate = new Date(currentDate);
      let formattedAttendanceDate = initialAttendanaceDate.toLocaleString(
        "pt-BR",
        { timeZoneName: "shortGeneric" },
      );
      formattedAttendanceDate = formattedAttendanceDate.replace("BRT", "");
      formattedAttendanceDate = formattedAttendanceDate.trim();
      return formattedAttendanceDate;
    }

    async function logoutUserAnotherSession() {
      await _authServices.logoutAnotherSession(userId.value);
      await authenticate({
        login: login.value,
        password: password.value,
      });
    }

    async function testarMiniApiIpReporter() {
      try {
        const res = await fetch("https://localhost:6201/api/get-ip");
        const raw = await res.text();
      } catch (err) {
        console.error("❌ Erro geral ao acessar a mini API:", err);
      }
    }

    return {
      meetsAll,
      canSubmit,
      icons,
      reqClasses,
      login,
      password,
      newPassword,
      confirmNewPassword,
      loading,
      alterarSenhaProxLogin,
      model,
      onSubmit,
      logoutUserAnotherSession,
    };
  },
};
</script>
<style lang="scss" scoped>
.password-reqs {
  list-style: none;
  padding-left: 0;
}

.password-reqs li {
  display: flex;
  align-items: center;
  line-height: 1.5;
  font-size: 0.8rem;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.password-reqs li.ok {
  color: #9eff38;
}
.password-reqs li.nok {
  color: #fff;
}
.box-roles {
  left: 100%;
  position: absolute;
  display: inline-block;
  white-space: nowrap;
  padding: 0.5rem;
  margin-left: 1rem;
  background: transparent;
}
.box-roles h6 {
  margin: 0;
  font-weight: 500;
}
.login-body {
  position: relative;
}
.login-footer {
  align-items: center;
}
.login-container {
  padding: 1rem;
  color: #fff;
  width: 49%;
  margin-left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 100%, 0)
    ),
    radial-gradient(
      133.17% 32.16% at 59.58% 51.43%,
      rgba(237, 241, 250, 0.696) 0,
      rgba(237, 241, 250, 0.435) 100%
    );
  box-shadow: 4px 0 4px rgb(0 0 0 / 5%);
  border-radius: 15px;
}

.form-login {
  position: relative;

  .btn-login {
    border-radius: 12px !important;
    padding: 5px 22px;
    width: 120px;
  }
}
@media (min-width: $breakpoint-md-min) {
  .login-container {
    max-width: 23rem;
  }
}

@media (min-width: $breakpoint-lg-max) {
  .login-container {
    max-width: 24rem;
    height: 54%;
  }
}

@media (max-width: $breakpoint-sm-max) {
  .login-container {
    max-width: 23rem;
  }
}

@media (max-width: $breakpoint-sm-min) {
  .spacing-login {
    left: 0;
  }

  .login-container {
    margin: 0 auto;
    top: 2rem;
    max-width: 20rem;
  }
  // .field-login,
  // .field-password {
  //   display: none;
  // }
  .box-roles {
    margin-left: 0;
    left: 0;
    margin-bottom: 1rem;
    position: relative;
    background: transparent;
    color: #fff;
    box-shadow: none;
    width: 100%;
  }
  .box-roles h6 {
    font-size: 1rem;
  }
  .password-reqs li {
    line-height: 1.5;
    font-size: 1rem;
  }
  .password-reqs li.ok {
    color: #00a103;
    //font-weight: bold;
  }
}

.doc-terms {
  color: #ffffff;
  text-decoration: none;
}

.doc-terms:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
